const MediaTypeEnum = Object.freeze({
  image: 'image',
  video: 'video',
  mp4: 'video/mp4',
})

export default MediaTypeEnum
